import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a3937bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "card card-feat" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-5 col-md-6" }
const _hoisted_6 = { class: "progress-wrapper" }
const _hoisted_7 = { class: "col-lg-7 col-md-6" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "alert alert-secondary" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 0,
  class: "alert alert-info my-2"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 0,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Vill du rekommendera en vän?", -1))
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-6 mb-3" }
const _hoisted_20 = { class: "col-md-6 mb-3" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "alert alert-secondary mt-3"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Tack för rekommendationen.", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "mt-3 pt-3 border-top border-light"
}
const _hoisted_26 = { class: "row align-items-end" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Behöver du hjälp med att hitta amorteringsunderlaget?", -1))
const _hoisted_28 = { class: "col-md-6 mb-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Välj vilken bank du har nedan i listan", -1))
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = {
  key: 0,
  class: "alert alert-secondary mb-2"
}
const _hoisted_33 = { class: "border-top border-light pt-3 mt-3" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_36 = {
  key: 2,
  class: "pt-3 mt-3"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Vill du boka en tid med en rådgivare istället? ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Klicka här. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mortgageFlowStatus, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "progress-step d-grid"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["btn btn-sm pe-none", {
                    'btn-primary': item.status == 'Current',
                    'btn-light': item.status == 'Upcoming',
                    'btn-primary-light': item.status == 'Done'
                  }])
                  }, [
                    _createElementVNode("span", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("small", null, _toDisplayString(item.title), 1)
                  ], 2)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (
                    _ctx.getBankName()?.startsWith('SBAB') &&
                    _ctx.app.purpose == 'PromissoryLetter' &&
                    _ctx.currentEvent.sbabText != null
                  )
                  ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.currentEvent.sbabText), 1))
                  : (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.currentEvent.text), 1)),
                (_ctx.app.purpose == 'Renegotiate')
                  ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.currentEvent.renegotiateText), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.currentEvent.instructions != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getInstructions(), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("small", null, [
                          _createTextVNode(_toDisplayString(item) + " ", 1),
                          (index == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                _createElementVNode("a", {
                                  href: _ctx.getBankLink(),
                                  target: "self"
                                }, _toDisplayString(_ctx.getBankName()), 9, _hoisted_15)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_ctx.currentEvent.showRecommendationForm == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.recommendationForm.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.recommendationForm.name) = $event)),
                    label: 'Namn',
                    required: true
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.recommendationForm.phoneNumber,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.recommendationForm.phoneNumber) = $event)),
                    label: 'Telefonnummer',
                    required: true,
                    numbersOnly: true
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendRecommendation())),
                class: "btn btn-outline",
                disabled: _ctx.Disabled
              }, " Skicka ", 8, _hoisted_21),
              (_ctx.recommendationSent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (
            _ctx.currentEvent.bankList != null &&
            _ctx.currentEvent.bankList.loanPurpose == _ctx.app.purpose
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.seletedBank) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentEvent.bankList.banks, (option, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: option.text
                      }, _toDisplayString(option.name), 9, _hoisted_30))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.seletedBank]
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  (_ctx.seletedBank)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("small", null, _toDisplayString(_ctx.seletedBank), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_33, [
          (_ctx.currentEvent.buttonText != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPage(_ctx.currentEvent.buttonText))),
                  class: "btn btn-primary"
                }, _toDisplayString(_ctx.currentEvent.buttonText), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentEvent.questionMissingText != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.currentEvent.questionMissingText), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.currentEvent.status == 'Created')
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _hoisted_37,
              _createVNode(_component_router_link, { to: { name: 'mortgage_book_advisor' } }, {
                default: _withCtx(() => [
                  _hoisted_38
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}